import type { UserProfile } from '@/http/OpenAPI/types/user-management';
import type { UserProfileApiResponse } from '@/http/types/userProfileApiResponse';

import { protectedResources } from '../authConfig';
import makeGetRequestAsync, {
  makePatchFormRequestAsync,
  makePatchRequestAsync,
  makePostRequestAsync
} from '../http/Helpers/httpRequestHelpers';
import { UserMessage } from './CompanyUserManagement/Messages/UserMessage';

const apiScopes = protectedResources.userManagementWebApi.scopes;
const baseUrl = protectedResources.userManagementWebApi.endpoint;

export default {
  async getParticularUserProfile(accountId: string) {
    const url = `${baseUrl}/api/UserManagement/UserProfile/User?accountId=${accountId}`;
    return makeGetRequestAsync<UserProfileApiResponse>(apiScopes, url);
  },
  async uploadImage(
    accountId: string | undefined,
    formFile: FormData,
    oldProfileFileName: string
  ) {
    const url = `${baseUrl}/api/UserManagement/UserProfile/UpdateProfileImage?accountId=${accountId}&oldProfileFileName=${oldProfileFileName}`;
    return (await makePatchFormRequestAsync(apiScopes, url, formFile)).status;
  },
  async updateUser(userProfile: UserProfile) {
    const url = `${baseUrl}/api/UserManagement/UserProfile/Update`;
    return (await makePatchRequestAsync(apiScopes, url, userProfile)).status;
  },
  async getUserRole(userId: number) {
    const url = `${baseUrl}/api/UserManagement/User/UserRole?userId=${userId}`;
    return makeGetRequestAsync<any>(apiScopes, url);
  },
  async getSearchHistory() {
    const url = `${baseUrl}/api/UserManagement/SearchHistory`;
    return makeGetRequestAsync<any[]>(apiScopes, url);
  },
  async AddSearchHistory(search: any) {
    const url = `${baseUrl}/api/UserManagement/SearchHistory`;
    return makePostRequestAsync(apiScopes, url, search);
  },
  async getAllCompanyUsers(companyId: number) {
    const url = `${baseUrl}/api/UserManagement/User/company/${companyId}`;
    return makeGetRequestAsync<UserMessage[]>(apiScopes, url);
  }
};
